import React from 'react';
import PropTypes from 'prop-types';
import { useColors } from '../../../hooks/useColors';

const StatCard = ({ title, value, subtitle, icon, className = '' }) => {
  const { semantic } = useColors();
  
  return (
    <div className={`${semantic.contentCardBg} ${semantic.contentCardBorder} rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow ${className}`}>
      <div className="flex items-center justify-between mb-2">
        <h3 className={`${semantic.contentCardHeading} text-sm font-medium`}>{title}</h3>
        {icon && <span className={`${semantic.contentCardText} opacity-80`}>{icon}</span>}
      </div>
      <div className="flex flex-col">
        <span className={`text-2xl font-bold ${semantic.contentCardText}`}>{value}</span>
        {subtitle && (
          <span className={`${semantic.contentCardText} opacity-80 text-sm mt-1`}>{subtitle}</span>
        )}
      </div>
    </div>
  );
};

StatCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  subtitle: PropTypes.string,
  icon: PropTypes.node,
  className: PropTypes.string
};

export default StatCard;

